import apiClient from "./client";

export async function fetchMessageTemplates({ search, channel, templateKey, skip = 0, limit = 50 } = {}) {
  const params = { skip, limit };
  if (search) {
    params.search = search;
  }
  if (channel) {
    params.channel = channel;
  }
  if (templateKey) {
    params.template_key = templateKey;
  }
  const { data } = await apiClient.get("/communications/templates", { params });
  return data;
}

export async function createMessageTemplate(payload) {
  const { data } = await apiClient.post("/communications/templates", payload);
  return data;
}

export async function updateMessageTemplate(templateId, payload) {
  const { data } = await apiClient.patch(`/communications/templates/${templateId}`, payload);
  return data;
}

export async function sendCommunication(payload) {
  const { data } = await apiClient.post("/communications/send", payload);
  return data;
}

export async function fetchCommunicationLogs({
  borrowerId,
  templateKey,
  channel,
  status,
  dateFrom,
  dateTo,
  search,
  skip = 0,
  limit = 50,
} = {}) {
  const params = { skip, limit };
  if (borrowerId) {
    params.borrower_id = borrowerId;
  }
  if (templateKey) {
    params.template_key = templateKey;
  }
  if (channel) {
    params.channel = channel;
  }
  if (status) {
    params.status = status;
  }
  if (dateFrom) {
    params.date_from = dateFrom;
  }
  if (dateTo) {
    params.date_to = dateTo;
  }
  if (search) {
    params.search = search;
  }
  const { data } = await apiClient.get("/communications/logs", { params });
  return data;
}

export async function fetchCommunicationLog(logId) {
  const { data } = await apiClient.get(`/communications/logs/${logId}`);
  return data;
}

export async function fetchCommunicationsHubSummary() {
  const { data } = await apiClient.get("/communications/hub/summary");
  return data;
}

export async function fetchCommunicationsHubChannels() {
  const { data } = await apiClient.get("/communications/hub/channels");
  return data;
}

export async function fetchCommunicationsEngagementPreview() {
  const { data } = await apiClient.get("/communications/hub/engagement");
  return data;
}

export async function retryCommunication(logId) {
  const { data } = await apiClient.post(`/communications/logs/${logId}/retry`);
  return data;
}

export async function fetchCommunicationSettings() {
  const { data } = await apiClient.get("/communications/settings");
  return data;
}

export async function updateCommunicationSettings(payload) {
  const { data } = await apiClient.patch("/communications/settings", payload);
  return data;
}

export async function toggleCommunicationAutomation(settingKey, enabled) {
  return updateCommunicationSettings({ [settingKey]: enabled });
}
